/* import __COLOCATED_TEMPLATE__ from './recent-orders.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type { ShopifyOrder } from '../shopify';

interface Signature {
  Args: {
    shopifyOrders?: ShopifyOrder[] | null;
  };
}

const RecentOrders = templateOnlyComponent<Signature>();
export default RecentOrders;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::RecentOrders': typeof RecentOrders;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/recent-orders': typeof RecentOrders;
  }
}
